<form novalidate #updateEmail="ngForm" (ngSubmit)="submit(updateEmail)">
  <div class="modal-body">
    <div class="form-group row">
      <label class="col-md-12 col-form-label">現在のメールアドレス：{{ member.email }}</label>
      <label class="col-md-12 col-form-label">メールアドレス</label>
      <div class="col-md-12">
        <input [disabled]="busy || blocked" type="email" class="form-control" [(ngModel)]="newEmail" name="newEmail" required email placeholder="新しいメールアドレス">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn bg-close text-white" type="button" (click)="cancel.emit()" [disabled]="busy"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
    <button class="btn btn-success" type="submit" [disabled]="updateEmail.invalid || updateEmail.pending || busy || blocked"><i class="fa s-icon-save"></i>&nbsp;保存</button>
  </div>
</form>
